import React, { useContext, useState, useEffect } from "react";
import Title from "../../common/Title";
import { useObserver } from "mobx-react";
import { Store } from "../../state/state";
import { toJS } from "mobx";
import TextField from "../../common/TextField";
import { SwatchesPicker } from "react-color";
import SwitchButton from "../../common/SwitchButton";
import Height_Width from "../../common/Height_Width";
import Margin_Field from "../../common/Margin_Field";

function SettingImage({}) {
  const [input, setInput] = useState(null);
  const store = useContext(Store);
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  useEffect(() => {
    let inputD = document.querySelector(`#${"input-" + store.select}`);
    // let [inputD] = dom.childNodes;
    console.log("dom input :", inputD);
    console.log("file ");
    inputD.addEventListener("input", async (event) => {
      console.log("select :", store.select);
      let id = store.select.substring(6, store.select.length);
      console.log("id :", id);
      const file = event.target.files[0];
      if (file) {
        console.log("FILE :", file);
        let src = await toBase64(file);
        store.theme.images[id].src = src;
        console.log("info :", toJS(store.theme.images[id]));
        store.theme.images[id].visible = true;
      } else store.theme.images[id].src = null;
    });
    setInput(inputD);
  }, [store.select]);

  return useObserver(() => (
    <div>
      <Title>الصورة او شعار</Title>
      <SwitchButton
        label={"إخفاء"}
        value={store.theme.images[store.select].visible}
        onChange={(e) => (store.theme.images[store.select].visible = e)}
      />
      <button
        className="bg-blue-600 text-white px-5 py-2 rounded shadow my-2"
        onClick={() => {
          console.log("select :", {
            [toJS(store.select)]: toJS(store.theme.images[store.select]),
          });
          console.log("input :", input);
          input.click();
        }}
      >
        تغيير رابط الصورة
      </button>
      <Height_Width />
      {/* <TextField
        label="الطول"
        value={store.theme.images[store.select].height}
        onChangeText={(txt) => (store.theme.images[store.select].height = txt)}
      />
      <TextField
        label="العرض"
        value={store.theme.images[store.select].width}
        onChangeText={(txt) => {
          console.log(txt);
          store.theme.images[store.select].width = txt;
        }}
      /> */}
      <div className="w-full flex items-center">
        <input
          type="range"
          name=""
          id=""
          step="0.1"
          max="1"
          value={store.theme.images[store.select].opacity}
          onChange={(e) => {
            store.theme.images[store.select].visible = true;
            store.theme.images[store.select].opacity = e.target.value;
          }}
        />
        <label className="flex-1 text-right">إخفاء :</label>
      </div>
      <Margin_Field />
    </div>
  ));
}

export default SettingImage;
